import { Button } from "@mui/material";
import { Checkbox, DatePicker, Input, InputNumber } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { Controller, useFormContext, useFieldArray } from "react-hook-form";


import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";

const InHouseInterestBox = (props) => {
  useEffect(() => {
    if (fields.length < 2) {
      const needed = 2 - fields.length;
      for (let i = 0; i < needed; i++) {
        append({ text: "" });
      }
    }
  }, []);
  const { index, tabsF } = props;
  const {
    control,
    trigger,
    formState: { errors },
    reset,
    getFieldState,
    setValue,
    watch,
    getValues,
  } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: `Interest.${index}.remarks`,
    // name: `remarks`
  });


  const viewMode = watch(`Interest.[${index}].view`);
  const minLoan = watch(`Interest.[${index}].minimum_loan_amount`);
  const maxLoan = watch(`Interest.[${index}].maximum_loan_amount`);
  const checkVal =
    watch(`Interest.[${index}].check_val`) === undefined
      ? "0"
      : watch(`Interest.[${index}].check_val`);
  const postData = {
    interest: getValues(`Interest.[${index}].interest`),
    startDate: getValues(`Interest.[${index}].startDate`)
      ? dayjs(getValues(`Interest.[${index}].startDate`)).format("DD MMM YYYY")
      : null,
    endDate: getValues(`Interest.[${index}].endDate`)
      ? dayjs(getValues(`Interest.[${index}].endDate`)).format("DD MMM YYYY")
      : "Further Notice",
    // remarks1: getValues(`Interest.[${index}].remarks1`),
    // remarks2: getValues(`Interest.[${index}].remarks2`),

    remarks: getValues(`remarks`),
    // remarks: getValues(`Interest.${index}.remarks`)

  };

  watch("remarks");

  const saveInterestData = async () => {
    await trigger("Interest", { shouldFocus: true });
    const formData = getFieldState("Interest");

    const currentRemarks = getValues("remarks");
    //console.log(" Remarks data on save:", currentRemarks);

    const { error } = formData;
    if (!error) {
      setValue(`Interest.[${index}].view`, true);
    }
  };
  const editData = () => {
    setValue(`Interest.[${index}].view`, false);
  };
  //console.log(' const editData', { editData });
  const delData = () => {
    const { Interest, ...restValues } = getValues();
    Interest[index] = {
      interest: "",
      startDate: "",
      endDate: "",
      // remarks1: "",
      // remarks2: "",
      remarks: [],
      minimum_loan_amount: "",
      maximum_loan_amount: "",
      view: false,
    };
    reset({
      ...restValues,
      Interest: Interest,
    });
    tabsF[index].schedDis = true;
  };

  //console.log("WTACHH", watch());
  return (
    <div className="p-[25px] bg-[#F9FBFD] ">
      {viewMode ? (
        <div>
          <div className="flex items-center gap-[10px_20px] mb-[15px] max-[600px]:flex-wrap">
            <div className="w-[80px]">
              <label className="block text-[13px] text-[#495159] mb-[6px]">
                Interest Rate
              </label>
              <p className="text-[13px] min-h-[20px]">{postData.interest}%</p>
            </div>
            <div>
              <label className="block text-[13px] text-[#495159] mb-[6px]">
                Publish Date
              </label>
              <p className="text-[13px] min-h-[20px]">{postData.startDate}</p>
            </div>
            <span className="text-[13px] mt-[27px] inline-block max-[600px]:w-full max-[600px]:mt-[2px]">
              To
            </span>
            <div>
              <label className="block text-[13px] text-[#495159] mb-[6px]">
                End Date
              </label>
              <p className="text-[13px] min-h-[20px]">{postData.endDate}</p>
            </div>
          </div>
          {/* <div className="mb-[15px]">
            <label className="block text-[13px] text-[#495159] mb-[6px]">
              Remarks 1
            </label>
            <p className="text-[13px] min-h-[20px]">{postData.remarks1}</p>
          </div>
          <div className="mb-[15px]">
            <label className="block text-[13px] text-[#495159] mb-[6px]">
              Remarks 2{" "}
            </label>
            <p className="text-[13px] min-h-[20px]">{postData.remarks2}</p>
          </div> */}

          {fields.length > 0 &&
            fields.map((remark, i) => (
              <div className="mb-[15px]" key={i}>
                <label className="block text-[13px] text-[#495159] mb-[6px]">
                  Remarks {i + 1}
                </label>
                <p className="text-[13px] min-h-[20px]">{remark.text}</p>
              </div>
            ))}

          <div className="flex items-center gap-[10px] mb-[25px] max-[600px]:flex-wrap">
            <div className="w-[152px]">
              <label className="block text-[13px] text-[#495159] mb-[6px]">
                Min. Loan Criteria
              </label>
              <p className="text-[13px] min-h-[20px]">
                {minLoan && `$${minLoan}`}
              </p>
            </div>
            <div className="w-[170px]">
              <label className="block text-[13px] text-[#495159] mb-[6px]">
                Else + Admin Fee
              </label>
              <p className="text-[13px] min-h-[20px]">
                {maxLoan && `$${maxLoan}`}
              </p>
            </div>
            <div>
              <label className="block text-[13px] text-[#495159] mb-[6px] relative">
                Statement Preview
              </label>
              <div className="min-h-[20px] pl-[5px]">
                {(minLoan || maxLoan) && (
                  <p className="text-[13px] font-[500]">
                    {minLoan && `Min. Loan $${minLoan}`}
                    {maxLoan && ` else + $${maxLoan} admin fee`}
                  </p>
                )}
              </div>
            </div>
          </div>
          <div>
            <Button
              type="button"
              className="sav_btn edit_btn"
              onClick={editData}
            >
              Edit
            </Button>
            <Button type="button" className="sav_btn del_btn" onClick={delData}>
              Delete
            </Button>
          </div>
        </div>
      ) : (
        <div>
          <div className="flex items-center gap-[10px] mb-[15px] max-[600px]:flex-wrap">
            <div className="w-[80px]">
              <label className="block text-[13px] text-[#495159] mb-[6px]">
                Interest Rate
              </label>
              <Controller
                control={control}
                name={`Interest.[${index}].interest`}
                rules={{
                  required: true,
                }}
                render={({ field, fieldState }) => {
                  return (
                    <InputNumber
                      {...field}
                      step="0.01"
                      precision={2}
                      type="number"
                      status={fieldState.error ? "error" : null}
                      prefix="%"
                      placeholder="0"
                      className="inhouseNum percent"
                    />
                  );
                }}
              />
            </div>
            <div>
              <label className="block text-[13px] text-[#495159] mb-[6px]">
                Publish Date
              </label>
              <Controller
                control={control}
                name={`Interest.[${index}].startDate`}
                rules={{
                  required: true,
                }}
                render={({ field, fieldState }) => {
                  return (
                    <DatePicker
                      {...field}
                      status={fieldState.error ? "error" : null}
                      placeholder="DD-MM-YYYY"
                      format="DD-MM-YYYY"
                      className="py-[8px]"
                      disabledDate={(d) =>
                        d.isBefore(dayjs().subtract(1, 'days'))
                      }
                      onChange={(date) => {
                        //console.log("DARRRRTEEE", date)
                        setValue(`Interest.[${index}].startDate`, date);
                        setValue(`Interest.[${index}].endDate`, "")
                      }}
                    />
                  );
                }}
              />
            </div>
            <span className="text-[13px] mt-[24px] inline-block max-[600px]:w-full max-[600px]:mt-[4px]">
              To
            </span>
            <div>
              <label className="block text-[13px] text-[#495159] mb-[6px]">
                End Date
              </label>
              <Controller
                control={control}
                name={`Interest.[${index}].endDate`}
                render={({ field }) => {
                  return (
                    <DatePicker
                      {...field}
                      placeholder="DD-MM-YYYY"
                      format="DD-MM-YYYY"
                      className="py-[8px]"
                      disabledDate={(d) =>
                        d.isBefore(dayjs(watch(`Interest.[${index}].startDate`)))
                      }
                    />
                  );
                }}
              />
            </div>
          </div>
          {/* <div className="mb-[15px]">
            <label className="block text-[13px] text-[#495159] mb-[6px]">
              Remarks 1
            </label>
            <Controller
              control={control}
              name={`Interest.[${index}].remarks1`}
              rules={{
                required: true,
              }}
              render={({ field, fieldState }) => {
                return (
                  <Input
                    {...field}
                    status={fieldState.error ? "error" : null}
                    placeholder="Remarks 1"
                    className="py-[8px]"
                  />
                );
              }}
            />
          </div>
          <div className="mb-[15px]">
            <label className="block text-[13px] text-[#495159] mb-[6px]">
              Remarks 2{" "}
            </label>
            <Controller
              control={control}
              name={`Interest.[${index}].remarks2`}
              render={({ field }) => {
                return (
                  <Input
                    {...field}
                    placeholder="Remarks 2"
                    className="py-[8px]"
                  />
                );
              }}
            />
          </div> */}

          <div className="mb-[20px]">
            {fields.map((field, i) => (
              <div style={{ display: "flex" }}>
                <div key={field.id} className="flex items-start gap-2 mb-[15px]" style={{ width: "95%" }}>
                  {/* Input Field */}
                  <div className="flex-1" >
                    <label className="block text-[13px] text-[#495159] mb-[6px]">
                      {`Remarks ${i + 1}`}
                    </label>
                    <Controller
                      control={control}
                      // name={`remarks.${i}.text`}
                      name={`Interest.${index}.remarks.${i}.text`}
                      rules={{ required: i === 0 }}
                      render={({ field, fieldState }) => (
                        <Input
                          {...field}
                          status={fieldState.error ? "error" : null}
                          placeholder={`Remarks ${i + 1}`}
                          className="py-[8px] w-full"
                        />
                      )}
                    />
                  </div>
                </div>
                {i > 0 && (<Button
                  type="text"
                  danger
                  onClick={() => remove(i)}
                  startIcon={<DeleteOutlined style={{ color: '#ff4d4f' }} />}
                  style={{ marginTop: '26px', marginRight: '-20px', width: "10%", height: '40px', width: '40px', minWidth: '40px' }}
                >
                </Button>)}
              </div>
            ))}

            <Button
              type="text"
              onClick={() => append({ text: "" })}
              startIcon={<PlusOutlined />}
              style={{ textTransform: 'capitalize' }}
            >
              Add More Remarks
            </Button>
          </div>

          <div className="flex items-center gap-[10px] mb-[25px] max-[600px]:flex-wrap">
            <div className="w-[152px]">
              <label className="block text-[13px] text-[#495159] mb-[6px]">
                Min. Loan Criteria
              </label>
              <Controller
                control={control}
                name={`Interest.[${index}].minimum_loan_amount`}
                rules={{
                  required: true,
                }}
                render={({ field, fieldState }) => {
                  return (
                    <InputNumber
                      {...field}
                      step="0.01"
                      precision={2}
                      type="number"
                      status={fieldState.error ? "error" : null}
                      prefix="$"
                      placeholder="0.00"
                      className="inhouseNum"
                    />
                  );
                }}
              />
            </div>
            <div className="w-[170px]">
              <label className="block text-[13px] text-[#495159] mb-[6px] pl-[25px] max-[417px]:pl-[0]">
                Else + Admin Fee
              </label>
              <div className="flex items-center">
                <Checkbox
                  className="mr-[10px]"
                  checked={checkVal === "1"}
                  onChange={() =>
                    setValue(
                      `Interest.[${index}].check_val`,
                      checkVal === "0" ? "1" : "0"
                    )
                  }
                />
                <Controller
                  control={control}
                  name={`Interest.[${index}].maximum_loan_amount`}
                  rules={{
                    required: checkVal === "1" ? true : false,
                  }}
                  render={({ field, fieldState }) => {
                    return (
                      <InputNumber
                        {...field}
                        step="0.01"
                        precision={2}
                        type="number"
                        status={fieldState.error ? "error" : null}
                        prefix="$"
                        placeholder="0.00"
                        className="inhouseNum"
                        disabled={checkVal === "0"}
                      />
                    );
                  }}
                />
              </div>
            </div>
            <div className="max-[600px]:w-full">
              <label className="block text-[13px] text-[#495159] mb-[6px] relative bottom-[10px] max-[600px]:bottom-[0]">
                Statement Preview
              </label>
              <div className="min-h-[20px] pl-[5px]">
                {(minLoan || maxLoan) && (
                  <p className="text-[13px] font-[500]">
                    {minLoan && `Min. Loan $${minLoan}`}
                    {maxLoan && ` else + $${maxLoan} admin fee`}
                  </p>
                )}
              </div>
            </div>
          </div>
          <div>
            <Button
              type="button"
              className="sav_btn"
              onClick={saveInterestData}
            >
              Save Changes
            </Button>
            {/* <Button type="button" className="can_btn">Cancel</Button> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default InHouseInterestBox;
